var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C15.662 17 18.865 18.575 20.607 20.925L18.765 21.796C17.347 20.116 14.847 19 12 19C9.15304 19 6.65304 20.116 5.23504 21.796L3.39404 20.924C5.13604 18.574 8.33804 17 12 17ZM12 2C13.3261 2 14.5979 2.52678 15.5356 3.46447C16.4733 4.40215 17 5.67392 17 7V10C17 11.2885 16.5025 12.5272 15.6114 13.4578C14.7203 14.3884 13.5043 14.9391 12.217 14.995L12 15C10.674 15 9.40219 14.4732 8.46451 13.5355C7.52683 12.5979 7.00004 11.3261 7.00004 10V7C7.00012 5.71154 7.49758 4.47284 8.3887 3.54222C9.27982 2.61161 10.4958 2.06092 11.783 2.005L12 2ZM12 4C11.2348 3.99996 10.4985 4.29233 9.94178 4.81728C9.38504 5.34224 9.04994 6.06011 9.00504 6.824L9.00004 7V10C8.99929 10.7809 9.30306 11.5313 9.84681 12.0918C10.3906 12.6523 11.1314 12.9787 11.912 13.0016C12.6926 13.0245 13.4513 12.7422 14.027 12.2145C14.6027 11.6869 14.95 10.9556 14.995 10.176L15 10V7C15 6.20435 14.684 5.44129 14.1214 4.87868C13.5588 4.31607 12.7957 4 12 4Z",
    fill: "#1D2C34"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.ba2c01810fc7fc4251f632c0a7d44f3f.svg";
export { ForwardRef as ReactComponent };